<template>
  <div class="card linha-produto mb-2" :class="{ 'linha-produto--ativa': item.ativo }">
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="idCheck"
          :checked="item.ativo"
          :disabled="disabled"
          @change="$emit('toggle', $event.target.checked)"
        />
        <label class="custom-control-label font-weight-bold" :for="idCheck">{{ produto.nome }}</label>
      </div>
      <BadgeStatusProduto :ativo="item.ativo" />
    </div>

    <div v-if="item.ativo" class="px-3 pb-3">
      <CamposIntegracaoDinamicos
        v-if="produto.campos && produto.campos.length"
        :campos="produto.campos"
        :valor="item.valor"
        :erros="erros"
        :disabled="disabled"
        @campo-input="$emit('campo-input', $event)"
      />

      <div v-if="!produto.usaTokenGrupo" class="form-group">
        <label :for="idObs">Observações</label>
        <textarea
          :id="idObs"
          class="form-control"
          rows="2"
          placeholder="Observações administrativas (opcional)"
          :disabled="disabled"
          :value="item.valor.observacoes"
          @input="$emit('campo-input', { campoChave: 'observacoes', valor: $event.target.value })"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import BadgeStatusProduto from './BadgeStatusProduto.vue'
import CamposIntegracaoDinamicos from './CamposIntegracaoDinamicos.vue'

export default {
  name: 'LinhaProduto',
  components: { BadgeStatusProduto, CamposIntegracaoDinamicos },
  props: {
    produto: { type: Object, required: true },
    item: { type: Object, required: true }, // { ativo, valor }
    erros: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    idCheck () { return 'produto-' + this.produto.slug },
    idObs () { return 'obs-' + this.produto.slug }
  }
}
</script>

<style scoped>
.linha-produto { border: 1px solid #e3e7ee; }
.linha-produto--ativa { border-color: #2f80ed; }
</style>
